export const texts = {
  da: {
    auth: {
      redirectError:
        'Noget gik galt under omdirigeringen. Prøv venligst igen senere.',
      title: 'Autentificering',
      unknownError:
        'Noget gik galt under godkendelsen. Prøv venligst igen senere.',
    },
    campaign: {
      bannerLabel: 'Kampagne',
      campaignAvailable: 'Kampagne tilgængelig',
      inputLabel: 'Kampagnekode',
      otherCampaigns: 'Andre kampagner',
      placeholder: 'Har du en kampagnekode? Tilføj her',
      submit: 'Tilføj kampagnekode',
      success: '$campaignCode$ er blevet tilføjet.',
    },
    close: 'Luk',
    corporateCode: {
      helpText: 'Du vil modtage en firma-rabatkode fra din arbejdsgiver.',
      label: 'Firma-rabatkode',
      placeholder: 'Har du en firma-rabatkode? Tilføj her',
      remove: 'Fjern firma-rabatkode',
      removed: 'Firma-rabatkode er fjernet',
      submit: 'Tilføj firma-rabatkode',
      success: '$corporateCode$ er blevet tilføjet.',
    },
    payment: {
      nextMonth: 'Hele $month$',
      restOfMonth: 'Resten af $month$ ($amount$ dager)',
      toPayNow: 'At betale nu',
      total: 'Total',
    },
    registration: {
      existingOtherPayerTabLabel: 'Eksisterende medlem',
      newOtherPayerTabLabel: 'Ikke medlem',
      otherPayerDescription: 'Nogen anden vil betale for dette medlemskab.',
    },
    seeMore: 'Se flere',
    startDate: {
      label: 'Hvornår vil du starte træningen?',
      today: 'I dag',
      tomorrow: 'I morgen',
      other: 'Anden dato',
    },
    noTermsAvailable: {
      message:
        'Noget gik galt, og vi kunne ikke indlæse vilkår og betingelser på denne side.',
      linkText: 'Læs vilkår og betingelser her',
    },
  },
  fi: {
    auth: {
      redirectError:
        'Jotain meni pieleen uudelleenohjauksessa. Kokeile myöhemmin uudestaan.',
      title: 'Todennus',
      unknownError:
        'Jotain meni pieleen kirjautumisessa. Kokeile myöhemmin uudestaan.',
    },
    campaign: {
      bannerLabel: 'Kampanja',
      campaignAvailable: 'Kampanja saatavilla',
      inputLabel: 'Kampanjakoodi',
      otherCampaigns: 'Muut kampanjat',
      placeholder: 'Onko sinulla kampanjakoodi? Käytä se täällä',
      submit: 'Käytä kampanjakoodi',
      success: '$campaignCode$ on otettu käyttöön onnistuneesti.',
    },
    close: 'Sulje',
    corporateCode: {
      helpText: 'Saat yrityskoodin työnantajaltasi.',
      label: 'Yrityskoodi',
      placeholder: 'Onko sinulla yrityskoodi? Käytä se täällä',
      remove: 'Poista yrityskoodi',
      removed: 'Yrityskoodi on onnistuneesti poistettu',
      submit: 'Käytä yrityskoodi',
      success: '$corporateCode$ on otettu käyttöön onnistuneesti.',
    },
    payment: {
      nextMonth: 'Koko $month$',
      restOfMonth: 'Loput kuukaudesta $month$ ($amount$ päivää)',
      toPayNow: 'Maksettavaa nyt',
      total: 'Yhteensä',
    },
    registration: {
      existingOtherPayerTabLabel: 'Nykyinen jäsen',
      newOtherPayerTabLabel: 'Ei jäsen',
      otherPayerDescription: 'Joku muu maksaa tämän jäsenyyden.',
    },
    seeMore: 'Näytä lisää',
    startDate: {
      label: 'Milloin haluat aloittaa harjoittelun?',
      today: 'Tänään',
      tomorrow: 'Huomenna',
      other: 'Muu päivämäärä',
    },
    noTermsAvailable: {
      message:
        'Jotain meni pieleen, emmekä pystyneet lataamaan käyttöehtoja tällä sivulla.',
      linkText: 'Löydä käyttöehdot täältä',
    },
  },
  no: {
    auth: {
      redirectError:
        'Noe gikk galt under omdirigeringen. Vennligst prøv igjen senere.',
      title: 'Autentisering',
      unknownError:
        'Noe gikk galt under autentiseringen. Vennligst prøv igjen senere.',
    },
    campaign: {
      bannerLabel: 'Kampanje',
      campaignAvailable: 'Kampanje tilgjengelig',
      inputLabel: 'Kampanjekode',
      otherCampaigns: 'Andre kampanjer',
      placeholder: 'Har du en kampanjekode? Legg til her',
      submit: 'Legg til kampanjekode',
      success: '$campaignCode$ har blitt lagt til i din bestilling.',
    },
    close: 'Lukk',
    corporateCode: {
      helpText: 'Bedriftskode får du utlevert av din arbeidsgiver.',
      label: 'Bedriftskode',
      placeholder: 'Har du en bedriftskode? Legg til her',
      remove: 'Fjern bedriftskode',
      removed: 'Bedriftskode fjernet',
      submit: 'Legg til bedriftskode',
      success: '$corporateCode$ har blitt lagt til i din bestilling.',
    },
    payment: {
      nextMonth: 'Hele $month$',
      restOfMonth: 'Resten av $month$ ($amount$ dager)',
      toPayNow: 'Å betale nå',
      total: 'Totalt',
    },
    registration: {
      existingOtherPayerTabLabel: 'Eksisterende medlem',
      newOtherPayerTabLabel: 'Ikke medlem',
      otherPayerDescription: 'Noen andre vil betale for dette medlemskapet.',
    },
    seeMore: 'Se flere',
    startDate: {
      label: 'Når vil du begynne treningen?',
      today: 'I dag',
      tomorrow: 'I morgen',
      other: 'Annen dato',
    },
    noTermsAvailable: {
      message: 'Vi klarte ikke laste inn vilkår og betingelser på denne siden.',
      linkText: 'Les vilkår og betingelser her',
    },
  },
  sv: {
    auth: {
      redirectError:
        'Något gick fel under omdirigeringen. Vänligen försök igen senare.',
      title: 'Autentisering',
      unknownError:
        'Något gick fel under autentiseringen. Vänligen försök igen senare.',
    },
    campaign: {
      bannerLabel: 'Kampanj',
      campaignAvailable: 'Kampanj tillgänglig',
      inputLabel: 'Kampanjkod',
      otherCampaigns: 'Andra kampanjer',
      placeholder: 'Har du en kampanjkod? Ange den här',
      submit: 'Använd kampanjkod',
      success: '$campaignCode$ har lagts till.',
    },
    close: 'Stäng',
    corporateCode: {
      helpText: 'Du får en företagskod från din arbetsgivare.',
      label: 'Företagskod',
      placeholder: 'Har du en företagskod? Ange den här',
      remove: 'Ta bort företagskod',
      removed: 'Företagskod har tagits bort',
      submit: 'Lägg till företagskod',
      success: '$corporateCode$ har lagts till.',
    },
    payment: {
      nextMonth: 'Hela $month$',
      restOfMonth: 'Resten av $month$ ($amount$ dagar)',
      toPayNow: 'Att betala nu',
      total: 'Totalt',
    },
    registration: {
      existingOtherPayerTabLabel: 'Existerande medlem',
      newOtherPayerTabLabel: 'Inte medlem',
      otherPayerDescription:
        'Någon annan kommer att betala för detta medlemskap.',
    },
    seeMore: 'Visa fler',
    startDate: {
      label: 'När vill du börja träna?',
      today: 'Idag',
      tomorrow: 'Imorgon',
      other: 'Annat datum',
    },
    noTermsAvailable: {
      message:
        'Något gick fel och vi kunde inte ladda villkor och bestämmelser på denna sida.',
      linkText: 'Läs villkor och bestämmelser här',
    },
  },
};
